export class SuspenseNullState {
	private resource: string
	private name: string
	constructor(resource: string) {
		this.name = 'SuspenseNullState'
		this.resource = resource
	}
}
